import { render } from "./NewItemsuggestionsComponent.vue?vue&type=template&id=3db4d8fa&scoped=true"
import script from "./NewItemsuggestionsComponent.vue?vue&type=script&lang=js"
export * from "./NewItemsuggestionsComponent.vue?vue&type=script&lang=js"

import "./NewItemsuggestionsComponent.vue?vue&type=style&index=0&id=3db4d8fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db4d8fa"]])

export default __exports__